// JavaScript Document


// スクロール
$(function(){
   // #で始まるアンカーをクリックした場合に処理
   $('.brandmenu a,#goToScroll a').click(function() {
      // スクロールの速度
      var speed = 200; // ミリ秒
      // アンカーの値取得
      var href= $(this).attr("href");
      // 移動先を取得
      var target = $(href == "#" || href == "" ? 'html' : href);
      // 移動先を数値で取得
      var position = target.offset().top;
      // スムーススクロール
      $('body,html').animate({scrollTop:position}, speed, 'swing');
      return false;
   });
});



// スマホ アコーディオン 

var mediaQuery = matchMedia('(max-width: 640px)');

// ページが読み込まれた時に実行
handle(mediaQuery);

// ウィンドウサイズが変更されても実行されるように
mediaQuery.addListener(handle);

function handle(mq) {
  if (mq.matches) {
    // ウィンドウサイズが640px以下のとき
$(function(){
	$(document).on("click", 'div.brandTitle', function() {
		$(this).next().slideToggle('fast');
		$(this).toggleClass("openBrand");
	});
	return false;
});	  
  } else {
    // それ以外
  }
}



//トップへ
jQuery(function() {
    var pagetop = $('#page_top');   
    pagetop.hide();
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {  //100pxスクロールしたら表示
            pagetop.fadeIn();
        } else {
            pagetop.fadeOut();
        }
    });
    pagetop.click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 200); //0.2秒かけてトップへ移動
        return false;
    });
});
